/**
 * 
 * @param {Object} formField - DOM element that of the "variant" form field that needs updating on the product form
 * @returns {Function(variantId{String})} function that takes the variant ID and returns an (impure) function that updates the field with the variant id 
 */


const updateVariantFormField = (formField, productHandle) => ((variant) => {
  if (variant) {
    let newVariantId = variant.id
    const pForm = document.querySelector(`[data-product-form="${productHandle}"]`)
    if (pForm) {
      const overrides = pForm.dataset.productOverrides;
      if (overrides) {
        const variantIdOverride = JSON.parse(overrides)[variant.id]
        if (variantIdOverride) {
          newVariantId = variantIdOverride
        }
      }
    }
    const btn = document.querySelector(`[data-product-form="${productHandle}"] [data-product-form-submit]`);
    if (btn) { btn.dataset.atcProductId = newVariantId; }
    formField.value = newVariantId
  }
})
export default updateVariantFormField;